import React, { useContext, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { groupContext } from "../index.js";
import Button from "../../../../../shared/ui/inputs/classicButton.js";
import ImageHovered from "../imageHovered/imageHovered.js";
import "./zoom.css";
export default function Zoom(props) {
    var _a, _b;
    const context = useContext(groupContext);
    const [openedImage, setOpenedImage] = useState(props.imageName);
    const [isHovered, setHovered] = useState(false);
    const imageCategory = context.categories.find((c) => c.images.some((i) => i.name === openedImage));
    const imageData = context.allImages.find((i) => i.name === openedImage);
    const imgProps = {
        offers: (_a = imageCategory === null || imageCategory === void 0 ? void 0 : imageCategory.offers.filter((offer) => offer.forEveryImage === true)) !== null && _a !== void 0 ? _a : [],
        imageUrl: `/api/public/users/gallery/image/${openedImage}`,
    };
    const images = context.categories.flatMap((c) => c.images);
    const currentImageIndex = (_b = images.findIndex((image) => image.name === openedImage)) !== null && _b !== void 0 ? _b : 0;
    useEffect(() => {
        const keyListener = (ev) => {
            const key = ev.key;
            switch (key) {
                case "Escape":
                    props.onClosed();
                    break;
                case "ArrowRight":
                    if (currentImageIndex < images.length - 1) {
                        const nextImage = images[currentImageIndex + 1].name;
                        setOpenedImage(nextImage);
                    }
                    break;
                case "ArrowLeft":
                    if (currentImageIndex > 0) {
                        const previousImage = images[currentImageIndex - 1].name;
                        setOpenedImage(previousImage);
                    }
                    break;
                default:
                    break;
            }
        };
        window.addEventListener("keydown", keyListener);
        return () => {
            window.removeEventListener("keydown", keyListener);
        };
    }, [openedImage]);
    return ReactDOM.createPortal(React.createElement("div", { className: "zoom-container" },
        currentImageIndex > 0 && (React.createElement(Button, { value: "previous", text: "poprzednie", onClick: () => {
                const previousImage = images[currentImageIndex - 1].name;
                setOpenedImage(previousImage);
            }, version: "alternative", classNames: "change-image-button change-image-button-left" },
            React.createElement("img", { width: 40, height: 100, style: { transform: "rotate(180deg)" }, src: "../../assets/icons/right-arrow.svg" }))),
        React.createElement("div", { className: "zoom-image-container", onMouseEnter: () => setHovered(true), onMouseLeave: () => setHovered(false), onTouchStart: () => setHovered(true), onMouseMove: () => (isHovered === false ? setHovered(true) : undefined) },
            React.createElement("img", { className: "zoom-image ph-no-capture", onContextMenu: (event) => event.preventDefault(), onDragStart: (event) => event.preventDefault(), style: { aspectRatio: String(imageData.aspectRatio) }, src: imgProps.imageUrl +
                    `?disablePreview=true&gallery=${context.galleryName}` }),
            React.createElement(Button, { text: "\u2716", value: "zoom_out", classNames: "zoom-out-button", onClick: () => {
                    props.onClosed();
                }, version: "alternative" }),
            props.withoutOrderButtons !== true && isHovered === true && (React.createElement(ImageHovered, { imageName: openedImage, imageUrl: imgProps.imageUrl, offers: imgProps.offers, openZoom: () => { }, showHoverEffect: false, showZoomButton: false, intentSource: "in-zoom" }))),
        currentImageIndex < images.length - 1 && (React.createElement(Button, { value: "next", text: "Nastepne", onClick: () => {
                const nextImage = images[currentImageIndex + 1].name;
                setOpenedImage(nextImage);
            }, version: "alternative", classNames: "change-image-button change-image-button-right" },
            React.createElement("img", { width: 40, height: 100, src: "../../assets/icons/right-arrow.svg" })))), document.querySelector("#zoom-container"));
}
